export default __webpack_public_path__ + "static/2.5.1/media/diagnosticianTopUp.cfc56e4e.svg";